import MakePictureVue from '@/views/member/make-picture/make-picture.vue';

const basePath = '/member/make-picture';
const role = 'member'; // 角色身份

export const M_MAKE_PICTURE_INDEX = 'm-make-picture-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MakePictureVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_MAKE_PICTURE_INDEX,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/make-picture/index`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
  ]
};
